import React, { useState } from "react";
import Loader from "Components/Loader";

const TermsPage = () => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div style={{ position: "relative", height: "100vh" }}>
      
      {isLoading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            background: "#fff",
          }}
        >
          <Loader />
        </div>
      )}

      <iframe
        src="https://ziloy.ae/terms-and-conditions/"
        title="Ziloy Terms Page"
        onLoad={() => setIsLoading(false)}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
        }}
      />
    </div>
  );
};

export default TermsPage;
